import React from 'react'
import { Text, Flex } from 'pcln-design-system'
import PropTypes from 'prop-types'

const SignedOutHeaderText = ({ inDollars, inPercent }) => (
  <>
    {inDollars > 0 && inPercent > 0 ? (
      <Flex>
        <Text fontWeight='bold'>Save ${inDollars}!</Text>
        <Text fontWeight='regular' ml={2}>
          That&apos;s {inPercent}% off the retail price
        </Text>
      </Flex>
    ) : null}
  </>
)

SignedOutHeaderText.propTypes = {
  inDollars: PropTypes.string,
  inPercent: PropTypes.string,
}

export { SignedOutHeaderText }
